
export const GlobalSettings = {
    RequireUrgentJobPhoto: "RequireUrgentJobPhoto"
}